import { useContext } from "react";
import { NavigationContext } from "@/providers/navigationProvider";
import Link from "next/link";
import styles from './styles.module.scss';

const TopLevel = () => {
    const context = useContext(NavigationContext);
    const {navItems, setCurrentNavId, currentNavId} = context || {};

    const handeClick = e => {
        e.preventDefault();
        const id = e.currentTarget.dataset.id;
        setCurrentNavId(id);
    }
    const renderTopLevelItems = () => {
        return navItems && navItems.map((item)=> {
            const id = item.id;
            return (
                <Link key={id} onClick={handeClick} data-id={id} href={`#`} className={`${styles.topLevel__item} ${currentNavId === item.id ? styles.topLevel__itemSelected : ``}`}>
                    {item?.label}
                </Link>
            );
        })
    }
      
    return(
        <nav className={styles.topLevel}>
            {renderTopLevelItems()}
        </nav>
    );
}

export default TopLevel;